/** @jsxImportSource @emotion/react */

/**
 * Firma discreta de la plataforma, abajo a la izquierda de cada pantalla.
 *
 * Va en el flujo normal (nada de `fixed`): cuando el contenido scrollea el
 * footer queda al final de todo en vez de tapar la última línea.
 *
 * `claro` es para fondos oscuros — en el public el fondo es el color principal
 * del organismo, así que ahí el texto va en blanco.
 */
export default function FooterMorfeo({ claro }) {
  return (
    <footer
      css={{
        // Alto fijo y declarado en una variable porque las pantallas de
        // ventana completa se lo restan a su 100vh.
        height: "var(--alturaFooter)",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        padding: "0 1.1rem",
        // Dentro de un contenedor flex vertical esto lo empuja hasta abajo
        // cuando el contenido no llega a llenar la ventana; fuera de flex no
        // hace nada.
        marginTop: "auto",
        fontSize: "0.68rem",
        lineHeight: 1,
        opacity: 0.4,
        transition: "opacity 0.2s",
        "&:hover": { opacity: 0.75 }
      }}
    >
      <a
        href="https://syntemis.com"
        target="_blank"
        rel="noopener noreferrer"
        // App.css pinta todos los links con --principal; sobre el fondo
        // principal del public eso queda ilegible.
        css={{
          "&:link, &:visited, &:hover, &:active": {
            color: claro ? "white" : "var(--negro)"
          }
        }}
      >
        Powered by Syntemis
      </a>
    </footer>
  );
}
